import { render, staticRenderFns } from "./LogoImg.vue?vue&type=template&id=bbe3fb86&"
import script from "./LogoImg.vue?vue&type=script&lang=ts&"
export * from "./LogoImg.vue?vue&type=script&lang=ts&"
import style0 from "./LogoImg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LogoImg.vue"
export default component.exports